module.exports = __webpack_public_path__ + "static/img/risk_core_value_bg_h5.3225404.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/productPartner/risk_core_value_bg_h5.png
// module id = T8+B
// module chunks = 34